import React from 'react';
import { Button, InputNumber, Space, Tooltip } from 'antd';
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons';
// Helper to get group size based on total
const getGroupSize = (total) => {
	if (total < 10) return 1;
	if (total < 50) return 5;
	if (total < 100) return 10;
	return 20;
};
// Helper to generate group pages
const getGroupedPages = (total) => {
	const groupSize = getGroupSize(total);
	const groupPages = [];
	for (let i = 1; i < total; i += groupSize) {
		groupPages.push(i);
	}
	// Ensure last number is included 
	if (total < 10) {
		if (groupPages[groupPages.length - 1] !== total) {
			groupPages.push(total);
		}
	}
	return groupPages;
};
const CustomPagination = ({ total, onJump, goToValue, setGoToValue, pageIndex, onClickNext, onClickPrev, nextDisable, prevDisable }) => {
	const groupPages = getGroupedPages(total);
	const handleGo = () => {
		if (
			goToValue &&
			!isNaN(goToValue) &&
			goToValue >= 1 &&
			goToValue <= total
		) {
			onJump?.(goToValue);
		}
	};
	return (
		<div className='my-3'>
			{/* Custom Group Buttons and Go To Input */}
			<Space
				style={{ gap: 8 }}
				size="small"
				wrap
			>
				<Tooltip placement="top" title="Previous"><Button onClick={() => onClickPrev()} type="text" icon={<LeftCircleOutlined/>} size="small" disabled={prevDisable}/></Tooltip>
				{groupPages?.map((page) => {
					const index = pageIndex + 1;
					const isActive = page === index;
					// Determine the current group start and end
					const groupSize = getGroupSize(total);
					const groupStart = Math.floor((index - 1) / groupSize) * groupSize + 1;
					const groupEnd = Math.min(groupStart + groupSize - 1, total);
					// Check if this page is in the current group
					const isInGroup = page >= groupStart && page <= groupEnd;
					return <Button
						key={page}
						onClick={() => onJump?.(page)}
						size='small'
						type={isActive ? "primary" : "default"}
						className={isActive ? "navy-btn" : isInGroup ? "navy-btn2": ""}
					>
						{page}
					</Button>;
				})}
				<Tooltip placement="top" title="Next"><Button onClick={() => onClickNext()} type="text" icon={<RightCircleOutlined/>} size="small" disabled={nextDisable}/></Tooltip>
				<div className='ml-3'>
					<InputNumber
						min={1}
						max={total}
						value={goToValue}
						onChange={setGoToValue}
						placeholder="Go to"
						style={{ width: 100 }}
						size='small'
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								handleGo();
							}
						}}
					/>
					<Button type="primary" onClick={handleGo} size='small' className='navy-btn'>
						Go
					</Button>
				</div>
			</Space>
		</div>
	);
};
export default CustomPagination;